// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"aa5bff74","260":"062da4d1","388":"12a7166f","768":"65078cde"}[chunkId] + ".chunk.js";
};